import Vue from 'vue'
export function showAlert(messageBody) {
  let options = {
    okText: 'Ok',
    type: 'basic',
    backdropClose: false,
    customClass: 'custom-confirm-alert'
  }
  let message = {
    title: 'Alert',
    body: messageBody
  }
  return Vue.dialog.alert(message, options)
}

export function showPrompt(messageBody, hideTitle = false) {
  let options = {
    okText: 'Ok',
    cancelText: 'Cancel',
    type: 'basic',
    backdropClose: true,
    customClass: 'custom-confirm-alert'
  }
  let message = {
    title: !hideTitle ? 'Prompt' : '',
    body: messageBody
  }
  return Vue.dialog.confirm(message, options)
}

export function confirm(messageBody) {
  let options = {
    okText: 'Yes',
    cancelText: 'No',
    type: 'basic',
    backdropClose: false,
    customClass: 'custom-confirm-delete'
  }
  let message = {
    title: 'Confirmation',
    body: messageBody
  }
  return Vue.dialog.confirm(message, options)
}



// WEBPACK FOOTER //
// ./src/utils/alert.js